import { render, staticRenderFns } from "./BusinessPartnerList.vue?vue&type=template&id=fc6bbb66&"
import script from "./BusinessPartnerList.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerList.vue?vue&type=style&index=0&id=fc6bbb66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports